module.exports = __webpack_public_path__ + "img/wtb7.21639f1d.png";